export default __webpack_public_path__ + "static/media/ic-front.bed79498.svg";